export const footer = {
  year: "2023 - 2026",
};
